import React from 'react';
import { Navbar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getOrgTermsContent } from '../content/utils.js';
import { selectUser, signOut } from '../modules/auth.js';
import { selectOrganization } from '../modules/organizations.js';
import AuthorizedAction from './AuthorizedAction.js';
import SiteHeaderActionDropdown from './SiteHeaderActionDropdown.jsx';
import UpdateProgressBannerContainer from '../containers/UpdateProgressBannerContainer.jsx';
import {
  OrganizationLink,
  ProjectReportsLink,
  ProjectsLink,
  AIChatLink,
} from './links/index.jsx';

const mapStateToProps = (state) => ({
  currentUser: selectUser(state),
  organization: selectOrganization(state),
});

const mapDispatchToProps = { signOut };

const SiteHeader = ({ hideNav, currentUser, organization, signOut }) => {
  const location = useLocation();
  const pathName = location.pathname.split('/')[1];

  const isReport =
    pathName === 'project-reports' || pathName === 'change-impact-reports';

  if (!currentUser || !organization) {
    return null;
  }

  return (
    <header>
      <UpdateProgressBannerContainer
        logo={
          currentUser && organization ? (
            !organization.logos?.length ||
            (organization.logos?.length &&
              organization.logos[organization.logos.length - 1].includes(
                'images/logo.png'
              )) ? (
              <span
                className="logo"
                style={{
                  background:
                    "url('/static/images/logo.svg') no-repeat center center",
                }}
              >
                ChangeSync
              </span>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  style={{ maxHeight: '60px', maxWidth: '180px' }}
                  src={organization.logos[organization.logos.length - 1]}
                />
                <span className="m-l-8">| Powered by ChangeSync</span>
              </div>
            )
          ) : null
        }
      />
      <Navbar collapseOnSelect fluid>
        {currentUser && organization ? (
          <Navbar.Header>
            <ProjectsLink>
              <span
                className="navbar-brand"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {!organization.logos?.length ||
                (organization.logos?.length &&
                  organization.logos[organization.logos.length - 1].includes(
                    'images/logo.png'
                  )) ? (
                  <span
                    className="logo"
                    style={{
                      background:
                        "url('/static/images/logo.svg') no-repeat center center",
                    }}
                  >
                    ChangeSync
                  </span>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      style={{ maxHeight: '60px', maxWidth: '180px' }}
                      src={organization.logos[organization.logos.length - 1]}
                    />
                    <span className="m-l-8">| Powered by ChangeSync</span>
                  </div>
                )}
              </span>
            </ProjectsLink>
            <Navbar.Toggle />
          </Navbar.Header>
        ) : null}

        {!hideNav ? (
          <Navbar.Collapse>
            <ul className="nav navbar-nav navbar-right flex flex-align-center">
              <li role="presentation">
                <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
              </li>
              <AuthorizedAction action="search" subject="project">
                <li role="presentation">
                  {!isReport ? (
                    <ProjectReportsLink>Reports</ProjectReportsLink>
                  ) : (
                    Reports
                  )}
                </li>
              </AuthorizedAction>
              <AuthorizedAction action="read" subject="organization">
                <li role="presentation">
                  <OrganizationLink>Organization</OrganizationLink>
                </li>
              </AuthorizedAction>
              {currentUser.aiAssistantAccess ? (
                <li role="presentation" className="nav-ai-item">
                  <AIChatLink>AI Assistant</AIChatLink>
                </li>
              ) : null}
              <li role="presentation">
                <SiteHeaderActionDropdown
                  signOut={signOut}
                  currentUser={currentUser}
                />
              </li>
            </ul>
          </Navbar.Collapse>
        ) : null}
      </Navbar>
    </header>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteHeader);
